'use strict';

/*global services*/
/*global blockElement*/
/*global unBlockElement*/

function DashboardSettings(containerID, settingsID) {
  this.containerID = containerID;
  this.settingsID = settingsID;
  this.$container = null;
  this.$containerSettings = null;

  this.init();
}

DashboardSettings.prototype = $.extend({}, {
  constructor: 'DashboardSettings',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '#' + _this.containerID + ' .remove-widget', function () {
      _this.removeWidget($(this).closest('.widget-wrapper'));
      return false;
    });

    $('body').on('click', '#' + _this.containerID + ' .remove-row', function () {
      _this.removeRow($(this).closest('.row'));
      return false;
    });

    $('body').on('click', '#' + _this.settingsID + ' .add-row', function () {
      _this.addRow();
      return false;
    });

    $('body').on('click', '#' + _this.containerID + ' .change-dim', function () {
      _this.changeDim($(this));
      return false;
    });

    $('body').on('click', '#' + _this.settingsID + ' .save', function () {
      _this.save();
      return false;
    });

    $('body').on('change', '#' + _this.containerID + ' .widget-height', function () {
      _this.changeWidgetHeight($(this).closest('.widget'), $(this).val());
      return false;
    });
  },

  //----------------------------------------------------------------------------

  loadWidgetSetting: function loadWidgetSetting($widget) {
    var widgetSettings = {
      dashboard_widget_id: $widget.find('input[name="dashboard_widget_id"]').val(),
      widget_id: $widget.data('widget_id'),
      delayed_loading: $widget.find('input[name="delayed_loading"]').is(':checked') ? 1 : 0,
      height: $widget.find('input[name="height"]:checked').val(),
      timestamp: $widget.find('input[name="timestamp"]').val()
    };

    return widgetSettings;
  },

  loadColumnSetting: function loadColumnSetting($column) {
    var _this = this;

    var columnSettings = {
      widgets: [],
      size: $column.data('size')
    };

    $column.find('.widget').each(function () {
      columnSettings.widgets.push(_this.loadWidgetSetting($(this)));
    });

    return columnSettings;
  },

  loadRowSetting: function loadRowSetting($row) {
    var _this = this;

    var rowSettings = {
      cols: []
    };

    $row.find('.column').each(function () {
      rowSettings.cols.push(_this.loadColumnSetting($(this)));
    });

    return rowSettings;
  },

  loadSettings: function loadSettings() {
    var _this = this;

    var settings = {
      rows: []
    };

    _this.$container.find('.row').each(function () {
      settings.rows.push(_this.loadRowSetting($(this)));
    });

    return settings;
  },

  save: function save() {
    var _this = this;

    var settings = _this.loadSettings();

    blockElement(_this.$containerSettings);
    $.post(services.get('router').path('save_dashboard_settings', { dashboardId: _this.$container.data('dashboard_id') }), { settings: settings }, function (res) {
      unBlockElement(_this.$containerSettings);

      if (res.msg === 'SUCCESS') {
        services.get('notifications').viewSaveMessage();
      } else {
        services.get('notifications').viewErrorMessage(services.get('translator').trans('settings.dashboard.save_failed'));
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  checkRows: function checkRows() {
    var _this = this;

    var $rows = _this.$container.find('.row');

    if ($rows.length > 1) {
      _this.$container.find('.remove-row').show();
    } else {
      _this.$container.find('.remove-row').hide();
    }

    return _this;
  },

  addRow: function addRow() {
    var _this = this;

    var $original = _this.$container.find('.row:last');
    var $clone = $original.clone();
    $clone.find('.column:not(:first)').remove();
    $clone.find('.column').attr('class', 'column col-md-12');
    $clone.find('.column .column-content').html('');

    $($clone).insertAfter($original);

    $clone.find('.column').each(function () {
      _this.initColumn($(this));
    });

    _this.checkRows();

    return _this;
  },

  removeRow: function removeRow($row) {
    var _this = this;

    $row.fadeOut('slow', function () {
      $(this).remove();

      _this.checkRows();
    });

    return _this;
  },

  changeDim: function changeDim($btn) {
    var _this = this;

    var $colSetting = $btn.find('span');
    var $row = $btn.closest('.row');

    //nejdrive srovname pocet sloupcu
    if ($row.find('.column').length > $colSetting.length) {
      //mam moc sloupcu
      while ($row.find('.column').length > $colSetting.length) {
        var $columnContent = $row.find('.column:last').find('.column-content').html();
        $row.find('.column:last').prev().find('.column-content').append($columnContent);
        $row.find('.column:last').remove();
      }
    } else if ($row.find('.column').length < $colSetting.length) {
      //mam malo sloupcu
      while ($row.find('.column').length < $colSetting.length) {
        var $newCol = $row.find('.column:last').clone();
        $newCol.find('.column-content').html('');
        $newCol.insertAfter($row.find('.column:last'));

        _this.initColumn($newCol);
      }
    }

    //nyni upravime dimenze
    $colSetting.each(function (index) {
      var $col = $(this);

      $row.find('.column').eq(index).attr('class', 'column ' + $col.data('size'));
      $row.find('.column').eq(index).data('size', $col.data('size'));
    });

    return _this;
  },

  changeWidgetHeight: function changeWidgetHeight($widget, height) {
    var _this = this;

    $widget.find('.widget-settings input[name="height"]').prop('checked', false);
    $widget.find('.widget-settings input[name="height"][value="' + height + '"]').prop('checked', true);

    $widget.find('.widget-content').attr('class', 'widget-content');
    $widget.find('.widget-content').addClass('widget-height-' + height);

    return _this;
  },

  removeWidget: function removeWidget($widgetWrapper) {
    var _this = this;

    $widgetWrapper.fadeOut('slow', function () {
      $(this).remove();
    });

    return _this;
  },

  loadWidgetPreview: function loadWidgetPreview($widget, $columnContent) {
    var _this = this;

    blockElement($columnContent);
    $.get(services.get('router').path('load_widget_preview', { dashboardId: _this.$container.data('dashboard_id'), widgetId: $widget.data('widget_id') }), function (res) {
      unBlockElement($columnContent);

      if (res.msg === 'SUCCESS') {
        var $widgetPreview = $(res.data.html);
        $columnContent.append($widgetPreview);

        _this.initWidget($widgetPreview);
      } else {
        services.get('notifications').viewErrorMessage(services.get('translator').trans('settings.dashboard.load_widget_failed'));
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  initWidget: function initWidget($widget, newWidget) {
    var _this = this;

    var draggableSettings = {
      containment: 'body',
      appendTo: 'body',
      zIndex: 100,
      revert: 'invalid',
      classes: {}
    };

    if (newWidget) {
      draggableSettings.helper = 'clone';
      draggableSettings.cursorAt = { left: 25, top: 10 };
      draggableSettings.classes = { 'ui-draggable-dragging': 'widget-source-dragging' };
    } else {
      draggableSettings.helper = 'original';
    }

    draggableSettings.classes['ui-draggable'] = 'widget-draggable';

    $widget.draggable(draggableSettings);

    return _this;
  },

  initWidgets: function initWidgets() {
    var _this = this;

    //nejdrive provedeme inicializaci widgetu ve sloupci nastaveni
    _this.$containerSettings.find('.widget-list').find('.widget').each(function () {
      _this.initWidget($(this), true);
    });

    //ted jiz tech vlozenych
    _this.$container.find('.column-content').find('.widget-wrapper').each(function () {
      _this.initWidget($(this), false);
    });

    return _this;
  },

  initColumn: function initColumn($column) {
    var _this = this;

    var $columnContent = $column.find('.column-content');
    $columnContent.droppable({
      accept: '.widget-draggable',
      tolerance: 'pointer',
      drop: function (event, ui) {
        var $widget = ui.draggable;

        if ($widget.hasClass('widget-source')) {
          _this.loadWidgetPreview($widget, $columnContent);
        } else {
          $widget.detach().appendTo($columnContent);
          $widget.css({ top: 0, left: 0 });
        }
      }
    });

    return _this;
  },

  initColumns: function initColumns() {
    var _this = this;

    _this.$container.find('.column').each(function () {
      _this.initColumn($(this));
    });

    return _this;
  },

  initRow: function initRow(/*$row*/) {
    var _this = this;

    return _this;
  },

  initRows: function initRows() {
    var _this = this;

    _this.$container.find('.row').each(function () {
      _this.initRow($(this));
    });

    return _this;
  },

  initContainer: function initContainer() {
    var _this = this;

    var sortableSettings = {
      handle: '.row-settings-move-handle',
      tolerance: 'pointer'
    };

    _this.$container.sortable(sortableSettings);

    return _this;
  },

  init: function init() {
    var _this = this;

    _this.$container = $('#' + _this.containerID);
    _this.$containerSettings = $('#' + _this.settingsID);

    if (_this.$container.length && _this.$containerSettings.length) {
      _this.registerCallbacks();
      _this.initWidgets();
      _this.initColumns();
      _this.initRows();
      _this.initContainer();
      _this.checkRows();
    }
  }
});
